export default "__VITE_ASSET__DDDykJnc__"